import React from 'react'
import SettingsMetaData from '../../../../../Components/Hooks/useSettingsMetaData'

function PaymentTerm() {
  return (
    <SettingsMetaData propertyName={"paymentTerms"} viewPropertyName={"Payment Term"} />
)
}

export default PaymentTerm